import React from "react";
const ErrorComponent = ({
  error,
  errorMessage
}) => {
  if (!error) return null;
  const getErrorMessage = () => {
    switch (error?.type) {
      case "required":
        return "This filed is required";
      case "min":
        return "Minimum value is";
      case "max":
        return "Maximum value is";
      case "minLength":
        return "Minimum characters count is";
      case "maxLength":
        return "Maximum characters count is";
      default:
        return errorMessage || "";
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "general-text",
    style: {
      color: "#D92D20",
      fontSize: "14px"
    }
  }, getErrorMessage());
};
export default ErrorComponent;
//# sourceMappingURL=Error.js.map